module.exports = __webpack_public_path__ + "static/assets/860e5ca89ee5c42facde0f021a17a06f.png";